<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { HTMLAttributes } from 'vue';

import Footer from './Footer.vue';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  title?: string;
}>();

if (props.title) {
  useHead({
    title: props.title,
  });
}
</script>

<template>
  <div :class="[$style.root, 'container-sm', props.class]">
    <slot></slot>
  </div>

  <Footer v-if="$slots.footer">
    <div :class="$style.footer">
      <div class="container-sm">
        <slot name="footer"></slot>
      </div>
    </div>
  </Footer>
</template>

<style lang="scss" module>
.root {
  margin-bottom: 4rem;
  font-size: 0.75rem;

  h2,
  h3 {
    font-family: Intro, sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.5em;
    font-weight: 500;

    // line-height: 1;
  }

  h2 {
    margin-bottom: 2rem;
    line-height: 1.5em;
    text-align: right;

    @include media-breakpoint-up(lg) {
      white-space: pre;
    }
  }

  @include media-breakpoint-up(lg) {
    h2 {
      width: 50%;
      transform: translateX(0.5em);
      margin-right: 2em;
    }

    :global(.hh) {
      display: flex;
      flex-direction: row;

      h3 {
        align-self: flex-end;
        flex-grow: 1;
        margin-bottom: 2.3rem;
        text-align: left;
      }
    }
  }

  h3 {
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1rem;
  }

  :not(h2) + h3 {
    margin-top: 2rem;
  }

  h4,
  :global(.h4) {
    font-family: Intro, sans-serif;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 0.75rem;
    letter-spacing: 0.7em;
    line-height: 1.5em;
  }

  > {
    :global(.spinner) {
      margin: 3rem auto 0;
      width: 5rem;

      :global(.spinner-border) {
        width: 5rem;
        height: 5rem;
      }
    }
  }

  :global(.embed-video) {
    display: inline-block;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: url('@/assets/images/btn-play.png') no-repeat;
      width: 51px;
      height: 51px;
      opacity: 0.6;
      transition: opacity 0.3s ease;
    }

    &:hover,
    &:focus {
      &::after {
        opacity: 1;
      }
    }
  }
}

.footer {
  border-top: 2px solid var(--#{$prefix}body-color);
  padding: 1rem 0;
  background: var(--#{$prefix}body-bg);
}
</style>
